import type { SvgIconComponent } from '@mui/icons-material'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import { auditEngagementFindingsPath, auditEngagementReportsPath } from '@/routes/paths'

/** One section of the Audit Engagements module. */
export interface AuditEngagementSection {
  key: string
  label: string
  /** One-line description used by the section's page header. */
  description: string
  icon: SvgIconComponent
  to: string
}

/**
 * Child sections of the Audit Engagements module, in display order.
 *
 * This is the single source for three things that must agree: the sidebar
 * accordion under "Audit Engagements", the module's routes, and the section
 * page headers. Adding a section is one entry here — no nav or route markup
 * changes.
 */
export const AUDIT_ENGAGEMENT_SECTIONS: readonly AuditEngagementSection[] = [
  {
    key: 'findings',
    label: 'Findings',
    description: 'Audit findings raised against engagements.',
    icon: FactCheckOutlinedIcon,
    to: auditEngagementFindingsPath(),
  },
  {
    key: 'reports',
    label: 'Reports',
    description: 'Reports issued for each audit engagement.',
    icon: DescriptionOutlinedIcon,
    to: auditEngagementReportsPath(),
  },
]

/** First section of the module — where `/engagements` lands. */
export const AUDIT_ENGAGEMENT_HOME = AUDIT_ENGAGEMENT_SECTIONS[0].to
